import React from 'react';
import styles from './CustomButton.module.css';

const CustomButton = ({
  text,
  description,
  leftIcon,
  rightIcon,
  onClick,
  className,
  disabled = false,
}) => {
  return (
    <div className={`${styles.buttonCustom} ${className}`} onClick={onClick} disabled={disabled}>
      <div className='d-flex justify-content-between align-items-center'>
        {leftIcon && <div className={styles.leftIcon}>{leftIcon}</div>}

        {rightIcon && <div className={styles.rightIcon}>{rightIcon}</div>}
      </div>

      <div className={styles.title}>{text}</div>
      {description && <div className="font-smaller fw-500 mt-1">{description}</div>}
    </div>
  );
};

export default CustomButton;
